import React from 'react';
import { Section } from '../ui/Section';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferStack() {
  const items = ['Método ENERGÍA REAL paso a paso', 'Mapa de fugas invisibles', "Plan 'Calma sin Culpa'", "Checklist 'Adultez Liviana'", 'Plan de acción 7 días'];
  return <Section background="light-pink" containerSize="md" data-id="element-212">
      <div className="bg-white border-2 border-fuchsia-200 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-213">
        <h2 className="text-3xl font-black text-slate-900 mb-8 text-center" data-id="element-214">
          Qué vas a{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-600 to-pink-600" data-id="element-215">
            recibir
          </span>
        </h2>

        <ul className="space-y-4 mb-8" data-id="element-216">
          {items.map((item, index) => <motion.li key={index} className="flex items-center gap-4 bg-gradient-to-r from-fuchsia-50 to-pink-50 p-4 rounded-xl border border-fuchsia-200 hover:border-fuchsia-400 transition-all shadow-sm" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.02,
          x: 5
        }} data-id="element-217">
              <CheckCircle2 className="w-6 h-6 text-fuchsia-500 flex-shrink-0" data-id="element-218" />
              <span className="text-lg font-medium text-slate-900" data-id="element-219">{item}</span>
            </motion.li>)}
        </ul>

        <div className="text-center text-slate-700 font-medium" data-id="element-220">
          Acceso inmediato y materiales descargables.
        </div>
      </div>
    </Section>;
}